// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/tailwind.scss
// module id = 10
// module chunks = 0